import type { AutocompleteRenderInputParams } from '@mui/material';

export type NamedInputParams = AutocompleteRenderInputParams & { placeholder?: string };

/**
 * Carries the placeholder into an Autocomplete's input params and, unless `labelled`, names the
 * input by it. Inside a settings row the row's `<label>` already points at the input's id, and an
 * aria-label would override that name.
 */
export const namedByPlaceholder = (
  params: AutocompleteRenderInputParams,
  placeholder: string | undefined,
  labelled = false,
): NamedInputParams =>
  labelled || !placeholder
    ? { ...params, placeholder }
    : { ...params, placeholder, inputProps: { ...params.inputProps, 'aria-label': placeholder } };
